export default __webpack_public_path__ + "static/media/easter-egg-gold.6fab5bf9.svg";